import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface SecuritySettings {
  maxFailedLogins: number;
  lockoutMinutes: number;
  rateLimitEnabled: boolean;
  authRateLimitMax: number;
  apiRateLimitMax: number;
  corsAllowedOrigins: string;
  authRateLimitWindowMs: number;
  apiRateLimitWindowMs: number;
  source: string;
}

export interface SecurityDashboard {
  windowDays: number;
  failedLogins: number;
  tokenReuse: number;
  rateLimited: number;
  accountLocked: number;
  lockedAccounts: number;
  byType: Record<string, number>;
  topIps: Array<{ ip: string; count: number }>;
}

export interface SuspiciousEvent {
  id: number;
  event_type: string;
  user_id: number | null;
  ip_address: string | null;
  path: string | null;
  detail: string | null;
  created_at: string;
}

export const securityApi = {
  async settings(): Promise<SecuritySettings> {
    return (await apiClient.get<ApiSuccess<SecuritySettings>>('/security/settings')).data.data;
  },
  async updateSettings(input: Partial<SecuritySettings>): Promise<SecuritySettings> {
    return (await apiClient.put<ApiSuccess<SecuritySettings>>('/security/settings', input)).data.data;
  },
  async dashboard(): Promise<SecurityDashboard> {
    return (await apiClient.get<ApiSuccess<SecurityDashboard>>('/security/dashboard')).data.data;
  },
  async suspicious(params: Record<string, unknown> = {}) {
    const { data } = await apiClient.get<ApiSuccess<SuspiciousEvent[]>>('/security/suspicious', { params });
    return { data: data.data, meta: data.meta };
  },
};
